import { Component } from '@angular/core';
import { NavController, NavParams,ViewController} from 'ionic-angular';
import {Api} from '../../providers/api';
import {CartManager} from '../../providers/cart-manager';
import {IMAGES_BASE_URL} from '../../providers/config';
import {GVLogger} from "../../services/gv-logger";

/**
 * Generated class for the ThankYouModalPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-thank-you-modal',
  templateUrl: 'thank-you-modal.html',
})
export class ThankYouModalPage {
	title = "";
	message= "";

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private viewCtrl:ViewController,
              private api:Api,
              private cartManager:CartManager,
              private gVLogger: GVLogger) {

  	this.gVLogger.log(this.navParams);
  	this.title = this.navParams.get('title');
  	this.message = this.navParams.get('message');
  }

  ionViewDidLoad() {

  }

  close(){
  	this.viewCtrl.dismiss();
  }

  getSquareLogo(){
    return IMAGES_BASE_URL.imageBaseUrl + "/" + this.cartManager.getADPCustomerUUID() + "/branding/logoSquare.png?v="+Math.round((new Date()).getTime() / 1000);
  }

  imageNotFoundServer(event){
    event.target.src = "http://anydatapoint.net/f9c5c5ba-3900-4cdc-946d-93979d29f33c/branding/default-logo.png";
   }

}



// WEBPACK FOOTER //
// ./src/pages/thank-you-modal/thank-you-modal.ts